import { cn } from '@/lib/utils';
import { Zap } from 'lucide-react';
import { LogoMark } from './Logo';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const sizeClasses = {
    sm: 'h-5 w-5 border-2',
    md: 'h-10 w-10 border-3',
    lg: 'h-16 w-16 border-4',
  };

  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div
        className={cn(
          'animate-spin rounded-full border-ink/10 border-t-brand-400',
          sizeClasses[size]
        )}
        role="status"
        aria-label="Carregando"
      >
        <span className="sr-only">Carregando...</span>
      </div>
    </div>
  );
}

export function LoadingScreen() {
  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <div className="h-14 w-14 animate-spin rounded-full border-4 border-ink/[0.06] border-t-brand-400" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Zap className="h-5 w-5 text-brand-400 animate-pulse" />
          </div>
        </div>
        <div className="flex flex-col items-center gap-1">
          <p className="text-sm font-medium text-ink/60">Carregando</p>
          <div className="flex gap-1">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-400 animate-bounce" style={{ animationDelay: '0ms' }} />
            <span className="h-1.5 w-1.5 rounded-full bg-brand-400 animate-bounce" style={{ animationDelay: '150ms' }} />
            <span className="h-1.5 w-1.5 rounded-full bg-brand-400 animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export function PageLoading() {
  return (
    <div className="flex h-screen items-center justify-center bg-canvas" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-5">
        <LogoMark className="h-12 w-12 animate-pulse-soft" />
        <div className="h-1 w-32 overflow-hidden rounded-full bg-ink/[0.08]">
          <div className="h-full w-1/3 animate-[loading-bar_1.1s_ease-in-out_infinite] rounded-full bg-brand-500" />
        </div>
        <span className="sr-only">Carregando…</span>
      </div>
    </div>
  );
}
